import { render, staticRenderFns } from "./SolutionView.vue?vue&type=template&id=4fd89459&scoped=true&"
import script from "./SolutionView.vue?vue&type=script&lang=js&"
export * from "./SolutionView.vue?vue&type=script&lang=js&"
import style0 from "./SolutionView.vue?vue&type=style&index=0&id=4fd89459&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd89459",
  null
  
)

export default component.exports